
<template>
  <div class="task-content" style="min-width:1160px" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="header">
        <div class="back"  @click="$router.go(-1)">返回</div>
        <div class="task-title">
          任务包派发审批
        </div>
    </div>
    <template v-if="detail.bizApproveVO&&detail.bizApproveVO.approveGuid">
      <div class="title">申请信息</div>
      <div class="approve-item-list">
        <div class="item first">
          <div class="label">
            申请人：
          </div>
          <div class="value">
            {{ detail.bizApproveVO.staffName||'-' }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            所在部门：
          </div>
          <div class="value">
            {{ detail.bizApproveVO.organisationName||'-' }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            提交时间：
          </div>
          <div class="value">
            {{ detail.bizApproveVO.createTime | getTimeDate }}
          </div>
        </div>
        <img v-if="detail.bizApproveVO.approveState=='C'" src="../../assets/images/ic_cancel.png" />
        <img v-if="detail.bizApproveVO.approveState=='Y'" src="../../assets/images/ic_pass.png" />
        <img v-if="detail.bizApproveVO.approveState=='A'" src="../../assets/images/ic_shenping.png" />
        <img v-if="detail.bizApproveVO.approveState=='R'" src="../../assets/images/ic_reject.png" />
      </div>
    </template>
    <div class="title">基本配置</div>
    <el-form label-width="120px" label-position="right" class="demo-ruleForm">
      <div class="basic-conetent">
        <div style="display: flex; width: 1000px">
          <el-form-item v-if="detail.taskTitle">
            <span slot="label">任务标题：</span>
            <div> {{ taskTitle && newTaskTitleTxt ? taskTitle + '(' + newTaskTitleTxt + ')' : taskTitle || '配置任务包' }}</div>
            <div></div>
          </el-form-item>
        </div>

        <div style="display: flex; width: 1000px">
          <el-form-item v-if="detail.tenantName" style="width: 500px">
            <span slot="label">委托方：</span>
            <div class="content-name" :title="tenantName">{{ tenantName }}</div>
            <div></div>
          </el-form-item>
          <el-form-item v-if="detail.serviceTenantName" style="width: 500px">
            <span slot="label">服务商：</span>
            <div class="content-name" :title="detail.serviceTenantName">{{ detail.serviceTenantName }}</div>
            <div></div>
          </el-form-item>
        </div>
        <div style="display: flex; width: 1000px">
          <el-form-item v-if="detail.organisationInfo" style="width: 500px">
            <span slot="label">执行部门： </span>
            <!--转派展示organisationInfo无转派展示organisationInfo-->
            <div style="text-align:left;line-height: 30px;width: 280px;">
              <el-tooltip :width="420"  effect="light" placement="top">
                <div slot="content">
                  <div v-if="getDepartmentNameAll(detail.oldOrganisationInfo||detail.organisationInfo,1)">部门：{{ getDepartmentNameAll(detail.oldOrganisationInfo||detail.organisationInfo,1) }}</div>
                  <div v-if="getDepartmentNameAll(detail.oldOrganisationInfo||detail.organisationInfo,2)">人员：{{ getDepartmentNameAll(detail.oldOrganisationInfo||detail.organisationInfo,2) }}</div>
                </div>
                <span>{{ getDepartmentName(detail.oldOrganisationInfo||detail.organisationInfo) }} </span>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="执行日期：" style="width: 500px" v-if="timeType == '按年' || timeType == '按月' || disabled">
            <div>{{ startTime }} 至 {{ endTime }}</div>
          </el-form-item>
        </div>
      </div>
   
      <!-- 任务包转派 开始 -->
      <section >
        <div class="title">任务包转派<i class="task-tips">（说明：表示此任务再次转派给其他执行方来完成）</i></div>
        <div class="basic-conetent">
          <div style="display: flex; width: 800px;margin-bottom:4px">
            <el-form-item v-if="detail.organisationInfo" style="width: 414px">
              <span slot="label">转派开关： </span>
              <el-radio-group v-model="isChangeService" :disabled="detail.state != '待受理'">
                <el-radio label="N">关闭</el-radio>
                <el-radio label="Y">开启</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div style="display: flex; width: 800px;" v-if="isChangeService=='Y'">
            <el-form-item style="width: 400px">
              <span slot="label" style="color: red">*</span>
              <span slot="label">新执行方： </span>
              <el-select v-if="detail.state == '待受理'" style="width:280px;" @change="handleSelectFactory" v-model="newServiceTenantName" filterable placeholder="请选择新执行方">
                <el-option v-for="(item, index) in tenantList" :key="index" :label="item.tenantName" :value="item.tenantName"></el-option>
              </el-select>
              <div v-if="detail.state != '待受理'">{{ detail.newServiceTenantName||'-' }}</div>
            </el-form-item>
            <div class="base-info">
              <div class="base-title" style="color:#606266"><span style="color: red">*</span>新执行部门：</div>
              <div class="depart-choose" v-if="detail.state == '待受理'" @click="chooseDepartmentPerson">
                <span v-if="departmentListII.length == 0" class="place-choose" >请选择</span>
                <span class="place-show" v-else>
                  <el-tooltip :width="420" effect="light"  placement="top">
                    <div slot="content">
                      <div v-if="getDepartmentNameAll(departmentListII,1)">部门：{{ getDepartmentNameAll(departmentListII,1) }}</div>
                      <div v-if="getDepartmentNameAll(departmentListII,2)">人员：{{ getDepartmentNameAll(departmentListII,2) }}</div>
                    </div>
                    <span>{{ this.getDepartmentName(departmentListII) }} </span>
                  </el-tooltip>
                </span>
              </div>
              <div style="border: 0 none" class="depart-choose" v-else>
                <el-tooltip :width="420" effect="light"  placement="top">
                  <div slot="content">
                    <div v-if="getDepartmentNameAll(detail.organisationInfo,1)">部门：{{ getDepartmentNameAll(detail.organisationInfo,1) }}</div>
                    <div v-if="getDepartmentNameAll(detail.organisationInfo,2)">人员：{{ getDepartmentNameAll(detail.organisationInfo,2) }}</div>
                  </div>
                  <span>{{ this.getDepartmentName(detail.organisationInfo) }} </span>
                  
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 任务包转派 结束 -->

      <!-- 任务明细 开始 -->
      <div class="title">任务明细</div>
      <div class="detail-table">
        <div class="search">
          <div class="name">姓名</div>
          <input  class="input" v-model="sumPage.keyword"  placeholder="请输入姓名"/>
          <div class="btn"  @click="search">搜索</div>
          <div class="btn gray" @click="emptySearch">清空</div>
          <p class="total-tip">
            费用金额合计：<span>{{ sumAmount | numDigit }}</span >
            元
          </p>
      </div>
        <div style="min-width:1060px">
        <el-table default-expand-all  :data="detailData" stripe  row-key="guid"    header-cell-class-name="table_header" :tree-props="{children: 'detailList'}">
          <el-table-column label="平台服务人员" width="120" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.staffName||'-' }}</template>
          </el-table-column>
          <el-table-column prop="taskType" label="任务大类"  header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskType || '-' }}</template>
          </el-table-column>
          <el-table-column label="任务名称" width="160" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskContentName||'-' }}</template>
          </el-table-column>
          <el-table-column label="单价" width="100" header-align="center" align="right">
            <template slot-scope="scope">
              <!-- 按比例 -->
              <span v-if="scope.row.settleRule==2">按比例计价</span>
              <!-- 按单价 -->
              <span v-else>{{ scope.row.taskPrice||'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="120" header-align="center" align="left">
            <template slot-scope="scope">
              <!-- 按比例 -->
              <span v-if="scope.row.settleRule==2">-</span>
              <!-- 按单价 -->
              <span v-else>{{scope.row.taskPriceUnit||'-'}}</span>
              <span style="color:#FF991C;"  v-if="scope.row.countRule">({{ scope.row.countRule }})</span>
            </template>
          </el-table-column>
          <el-table-column label="占比(%)" width="100" :render-header="renderHeaderI" header-align="center" align="right">
            <template slot-scope="scope">
              <!-- 按比例 或者 不限量 -->
              <span v-if="scope.row.settleRule==2||scope.row.isNotLimit==1">-</span>
              <!--其他 -->
              <span v-else>{{ scope.row.percent?toDecimal2(scope.row.percent):'-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="费用金额(元)" width="140" :render-header="renderHeaderII" header-align="center" align="right">
            <template slot-scope="scope">
              <!-- 按比例 或者 不限量 -->
              <span v-if="scope.row.settleRule==2||scope.row.isNotLimit==1">-</span>
              <!-- 按单价 -->
              <span v-else>{{ scope.row.amountTotal | numFmt | numDigit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="计划量" width="100" :render-header="renderHeaderIII" header-align="center" align="right">
            <template slot-scope="scope">
              <!-- 按单价 且不限量-->
              <span v-if="scope.row.isNotLimit==1">不限量</span>
              <!-- 其他 -->
              <span v-else>{{scope.row.planCount||'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="计算方式" width="100" header-align="center" align="left">
              <template slot-scope="scope">
                <span >{{scope.row. taskTotalType||'-'}}</span>
              </template>
          </el-table-column>
          <el-table-column label="超量上限拦截" width="120" header-align="center" align="left">
            <template slot-scope="scope">
              <span >{{scope.row. isOpenMaxTask | isOverFilter}} {{ scope.row. maxTaskValue |isOverValueFilter}}</span>
            </template>
          </el-table-column>
        </el-table> 
        </div>
        <el-pagination style="margin-top:20px;    width: 840px" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange"  :page-sizes="[10,20,50,100,200]" :current-page="sumPage.pageIndex"
          :page-size="sumPage.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="sumPage.totalRows">
        </el-pagination>
      </div>
      <!-- 任务束 -->
      <!-- 流程 开始 -->
      <div class="flow">
        <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
      </div>
      <!-- 流程结束 -->

      <div class="btn-groups">
        <el-button class="btn-common btn-border-gray" size="mini" type="info" @click="$router.go(-1)">取消</el-button>
        <el-button class="btn-common btn-border-green" size="mini" type="info"  @click="toRevoke" v-if="detail.bizApproveVO&&detail.bizApproveVO.approveState == 'A'&&detail.bizApproveVO.staffGuid==currentStaffGuid">撤销</el-button>
        <el-button class="btn-common btn-border-green" size="mini" type="info"  @click="rejectDialogVisible=true" v-if="detail.bizApproveVO&&detail.bizApproveVO.approveState == 'A'&&detail.bizApproveVO.approveStaffGuids.indexOf(currentStaffGuid)>-1">驳回</el-button>
        <el-button class="btn-common" size="mini" type="info" @click="passDialogVisible=true" v-if="detail.bizApproveVO&&detail.bizApproveVO.approveState == 'A'&&detail.bizApproveVO.approveStaffGuids.indexOf(currentStaffGuid)>-1">通过</el-button>
      </div>
    </el-form>

    <el-dialog title="填写品种任务量" :visible.sync="visible2" width="40%" center>
      <el-table border :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="产品名称" show-overflow-tooltip header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column prop="name" label="任务量" width="180" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.goodsCount" :min="0" :step="1" size="small" v-if="detail.state == '待受理'"></el-input-number>
            <div v-else>
              {{ scope.row.goodsCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="产品规格" show-overflow-tooltip header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.goodsSpec }}</template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible2 = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitForm()">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="任务分解" :visible.sync="visible4" width="70%" center>
      <div class="title-search">
        <div>
        合计：该任务，总任务量：<span class="txt-color">{{detail.taskTotalType !='不限量'? taskDetail.taskTotal:'不限量' }}</span><span v-if="taskDetail.taskTotal">{{ taskDetail.taskTotalUnit }}</span>，已分解给
        <span class="txt-color">
          {{ taskDetail.taskDetailOrganisationList && taskDetail.taskDetailOrganisationList.length }}</span>个部门，<span class="txt-color">{{ taskDetail.staffTotal }}</span>个人员
        </div>
        <el-input v-model="serachOrgTxt" clearable class="search-box" placeholder="请输入组织"></el-input>
      </div>
    
      <el-table border :data="tableOrg" style="width: 100%">
        <el-table-column v-for="(item, index) in tabHead" :label="item.label" :property="item.property" :key="index" show-overflow-tooltip header-align="center" align="center">
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <a class="txt-color" v-if="detail.state == '待派发' || detail.state == '已派发'" @click="seePeople(scope.row)">查看人员明细</a>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="任务分解" :visible.sync="visible5" width="70%" center>
        <div class="title-search">
          <div >
            当前部门：{{ taskStaffDetail.organisationName }}，任务总量：<span class="txt-color">{{
              taskStaffDetail.planCount
            }}</span><span v-if="taskStaffDetail.planCount!='不限量'">{{ taskDetail.taskTotalUnit }}</span>，已分解<span class="txt-color">{{
              taskStaffDetail.taskDetailStaffList && taskStaffDetail.taskDetailStaffList.length
            }}</span>个人员
          </div>
        <el-input v-model="serachPeopleTxt" clearable class="search-box" placeholder="请输入名称"></el-input>
      </div>
      <el-table border :data="tableStaff" style="width: 100%">
        <el-table-column v-for="(item, index) in tabHeadII" :label="item.label" :property="item.property" :key="index" header-align="center" align="center">
          <template slot-scope="scope">
            <input  v-if="scope.column.property !== 'staffName'&&scope.row[scope.column.property]!='不限量'&&detail.timeState!='已结束'" style="width: 100px !important" size="small" class="el-input__inner" v-model="scope.row[scope.column.property]" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" />
            <div v-else>{{ scope.row[scope.column.property] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer t-right"  v-if="detail.timeState!='已结束'">
        <el-button plain size="medium" @click="visible5 = false">取消</el-button>
        <el-button size="medium" type="info" @click="modifyStaff">确定</el-button>
      </div>
    </el-dialog>
    <!-- <div v-if="visible6">
      <el-dialog title="批量调整任务" :visible.sync="visible6" width="45%" center>
        <div class="row-import">
          <div class="left">下载模板</div>
          <div class="right">
            <el-button type="info" @click="downloadTemplate" size="small">下载任务清单</el-button>
            <div class="tipInfo">
              注意事项：<br />
              1、 请先下载任务清单，任务清单中是当前系统自动分解后每个人的任务量明细；<br />
              2、下载后，直接修改里面的任务量数值，再导入，即可批量调整人员任务量
            </div>
          </div>
        </div>
        <div class="row-import">
          <div class="left">导入文件</div>
          <div class="right">
            <el-upload class="avatar-uploader" action="#" :limit="1" :before-upload="beforeAvatarUpload" :http-request="uploadImage" multiple>
              <el-button size="small" type="info">点击上传文件</el-button>
            </el-upload>
            <div class="tipInfo">
              注意事项：<br />
              1、点击文件，选择修改好的任务清单文件上传；<br />
              2、仅支持excel文件，大小
              <=10M；<br />
              3、使用 Office 2010 及以上版本，避免出现乱码<br />
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer t-right">
          <el-button plain size="medium" @click="visible6 = false">取消</el-button>
          <el-button size="medium" type="info" @click="modifyUplad">确定</el-button>
        </div>
      </el-dialog>
    </div> -->
     <!-- 选择部门人员 开始 -->
    <ChooseUser ref="chooseDepartment" :tenantGuid="newServiceTenantGuid" @onSelect="onDepartmentSelect"></ChooseUser>
    <!-- 选择部门人员 结束 -->

    <el-dialog title="修改人员任务" :visible.sync="visible8" width="500px" :close-on-click-modal='false'>
      <template v-if="visible8">
        <el-form label-width="120px" class="demo-ruleForm">
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择任务：</span>
            <el-select v-model="taskDetailGuid" placeholder="请选择任务" filterable class="fl" style="width: 300px" @change="taskChange">
              <el-option v-for="item in tableDataII" :key="item.guid" :label="item.taskContentName" :value="item.guid"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form label-width="120px" class="demo-ruleForm">
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择人员：</span>
            <el-select v-model="staffGuid" placeholder="请选择人员" filterable class="fl" style="width: 300px" @change="staffChange">
              <el-option v-for="item in staffList" :key="item.staffGuid" :label="item.staffName+'-'+item.mobileNo" :value="item.staffGuid"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form label-width="120px" class="demo-ruleForm" v-if="organisationNames">
          <el-form-item>
            <span slot="label">所属组织：</span>
            <div>{{organisationNames}}</div>
          </el-form-item>
        </el-form>
        <el-form label-width="120px" class="demo-ruleForm">
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">任务量：</span>
            <el-input type="number" min="0" v-model="taskCount" placeholder="请填写任务量" style="width: 300px"></el-input>
          </el-form-item>
        </el-form>
        <div class="task-tips" style="text-align:left;padding-left:120px;">注意：若数量修改为0，则人员任务删除，无法继续执行此任务，请慎重修改。</div>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" plain @click="visible8 = false">取 消</el-button>
          <el-button size="medium" type="info" @click="sureTaskModify">提 交</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog class="ai-class" title="查看预测规则" :visible.sync="visible10" width="50%" center>

      <div class="ai-content">
        <div class="ai-item">
          <span class="lable">执行部门：</span>
          <span class="value">{{autoForecastJson.parmValue1}}</span>
          <span class="ai-color" v-if="autoForecastJson.parmValue3">其中{{ autoForecastJson.parmValue3 }}人无历史数据无法预测</span>
        </div>
        <div class="ai-item">
          <span class="lable">预测总额：</span>
          <span class="value">{{autoForecastJson.parmValue2}}元</span>
          <span class="other1">(大写:{{autoForecastJson.parmValue2 | smallToBig}})</span>
        </div>
      </div>
      <div class="download-btns">
        <span class="lable">预测规则：</span>
      </div>
      <el-table :data="autoForecastJson.detailParam" border style="width: 100%;margin:20px 0;">
        <el-table-column prop="taskContentName" label="任务名称" header-align="center" align="center">
        </el-table-column>
        <el-table-column label="任务占比" header-align="center" align="center">
          <template slot-scope="scope">
            <div style="display:flex;align-items:center;justify-content:center;">
              <span>{{scope.row.taskTotalPercent}}%</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="任务单价" header-align="center" align="center">
          <template slot-scope="scope">
            {{scope.row.taskPrice}}{{scope.row.taskPriceUnit}}
          </template>
        </el-table-column>
        <el-table-column label="任务量" header-align="center" align="center">
          <template slot-scope="scope">
            {{scope.row.foreCastTaskTotal}}
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="visible10 = false">关闭</el-button>
      </span>
    </el-dialog>


    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea"   maxlength="100" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea"  maxlength="100" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import moment from 'moment';
  import {bpmnroute } from '@/api/apiRoute';
  import ChooseUser from './components/chooseUser';
  export default {
    components: {
      ChooseUser
    },
    data() {
      let userinfo = JSON.parse(localStorage.userInfo);
      return {
        hasChildren: true,
        sumPage:{
          pageIndex: 1,
          pageSize: 10,
          totalPage: 0,
          totalRows: 0,
          tenantGuid: '',
          taskMainGuid:this.$route.query.guid,
          keyword:'',
          approveGuid:this.$route.query.approveGuid,
          showChangeOnly:'N'
        },
        detailData:[],
        detailHeader:['序号','平台服务人员','任务名称','单价','单位','占比（%)','费用金额（元）','计划量'],
        rejectDialogVisible:false,
        passDialogVisible:false,
        approveSuggest:'',
        iframeSh:false,
        iframeSrc:'',
        currentStaffGuid:userinfo.staffGuid,

        newTaskTitleTxt:'',
        visible10:false,
        timeType: '',
        timeRange: '',
        year: '',
        month: '',
        startTime: '',
        endTime: '',
        taskTitle: '',
        tenantName: '',
        tenantList: [],
        taskContentList: [],
        tableDataII: [],
        visible2: false,
        page: {
          pageIndex: 1,
          pageSize: 50,
          totalPage: 0,
          totalRows: 0,
          taskContentName: '',
          tenantName: '',
          isUse: 'Y',
          tenantGuid: localStorage.guid,
          serviceTenantGuid: localStorage.guid
        },
        tableData: [],
        multipleSelection: [],
        fullscreenLoading: false,
        disabled: false,
        detail: {},

        goodsIndex: 0,

        visible4: false,
        taskDetail: {},
        tableOrg: [],
        tabHead: [],

        visible5: false,
        tableStaff: [],
        tabHeadII: [],
        taskStaffDetail: {},

        visible6: false,
        fileList: [],

        sendTenantList: [],

        supertubeFlag: localStorage.supertubeFlag,//当前用户是否是超级运营公司
        // changeServiceType:'2',//默认是药企
        isChangeService: 'N',//是否转派
        newServiceTenantName: '',//新执行公司
        newServiceTenantGuid: '',
        visible7: false,
        departmentListII: [],
        filterTextII: '',
        areaDataII: [],
        delListII: [],
        filterTextII: '',
        organisationInfo: null,
        defaultPropsII: {
          id: 'guid',
          label: 'organisationName',
          children: 'children',
          disabled: this.disabledTreeNode,
        },

        visible8: false,
        taskDetailGuid: '',
        staffGuid: '',
        staffList: [],
        taskCount: '',
        detailGuid: '',
        organisationNames: '',
        serachOrgTxt:'',
        tableOriginOrg:[],
        serachPeopleTxt:'',
        tableOriginStaff:[],
        autoForecastJson:{
            parmValue1:'',
            parmValue2:'',
            parmValue3:'',
            detailParam:[]

        },
        sumAmount:null,//费用合计

      };
    },
    filters:{
      isOverFilter(val) {
        let objStr = {
          Y: '是，',
          N: '否，',
        };
        return objStr[val] || '';
      },
      isOverValueFilter(val) {
        let str='-'
        if(val ||val==0){
          str=val +'%'
        }
        return str;
      },
    },
    created() {
      this.getOpertateList();
      this.getDetail();
      //this.getSendTenantList();
    },
    watch: {
      serachOrgTxt(val){
        var tableOriginOrg = this.tableOriginOrg;
        console.log(tableOriginOrg)
        if(!val){
          this.tableOrg = tableOriginOrg;
        }else{
          var str = tableOriginOrg
          var key = val;
          var arr=[]
          for (let index = 0; index < tableOriginOrg.length; index++) {
          if (str[index].organisationName.indexOf(key)>=0) {
            arr.push(str[index]);//返回满足条件的数据
          }}
          this.tableOrg = arr;
        }

      },
      serachPeopleTxt(val){
        var tableOriginStaff = this.tableOriginStaff;
        console.log(tableOriginStaff)
        if(!val){
          this.tableStaff = tableOriginStaff;
        }else{
          var str = tableOriginStaff
          var key = val;
          var arr=[]
          for (let index = 0; index < tableOriginStaff.length; index++) {
          if (str[index].staffName.indexOf(key)>=0) {
            arr.push(str[index]);//返回满足条件的数据
          }}
          this.tableStaff = arr;
        }

      },
      year(year) {
        if (this.disabled) return;
        if (!year) return;
        this.startTime = year + '-01-01';
        this.endTime = year + '-12-31';
      },
      month(month) {
        if (this.disabled) return;
        if (!month) return;
        var tenantList = this.tenantList;
        var tenantGuid;
        var reqDate = month + '-01';
        tenantList.forEach((item) => {
          if (item.tenantName == this.tenantName) {
            tenantGuid = item.guid;
          }
        });
        if (!tenantGuid) return;
        this.api
          .get(
            `/${serverConfig.msConfigureService}/sysparameter/data/get-account-month-full-area?date=` +
            reqDate +
            '&tenantGuid=' +
            tenantGuid,
          )
          .then((resp) => {
            if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.startTime = resp.data.data.split(',')[0];
              this.endTime = resp.data.data.split(',')[1];
            }
          });
      },
      timeType() {
        if (this.disabled) return;
        this.startTime = '';
        this.endTime = '';
        this.year = '';
        this.month = '';
      },
    },
    methods: {
      getSumAmount(list, type) {
        let sum = 0;
        if (type == 1) {
          list.forEach((item) => {
            sum += Math.round(item.amountTotal * 100) / 100 ;
          });
        }
        return sum;
      },
      toDecimal2(x) {
        var f = parseFloat(x);
        if (isNaN(f)) {
          return false;
        }
        var f = Math.round(x * 100) / 100;
        var s = f.toString();
        var rs = s.indexOf('.');
        if (rs < 0) {
          rs = s.length;
          s += '.';
        }
        while (s.length <= rs + 2) {
          s += '0';
        }
        return s;
      },
      getOpertateList() {
        let self = this;
        self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, { 'pageIndex': 1, 'pageSize': -1, 'enterpriseCates': ['9901'] }).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data.records;
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      renderHeaderI: function (h, { column, $index }) {
        return [
          column.label,
          h(
            'el-tooltip',
            {
              props: {
                placement: 'top',
                effect: 'dark',
                //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
              },
            },
            [
              h(
                'div',
                {
                  //当前div是为了实现换行，就这换行研究了好久。。。
                  slot: 'content',
                },
                ['某个业务员某个任务的费用金额/该业务员任务金额合计的%；'],
              ),
              h('span', {
                //问号模块
                class: {
                  'el-icon-question': true,
                },
              }),
            ],
          ),
        ];
      },
      renderHeaderII: function (h, { column, $index }) {
        return [
          column.label,
          h(
            'el-tooltip',
            {
              props: {
                placement: 'top',
                effect: 'dark',
                //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
              },
            },
            [
              h(
                'div',
                {
                  //当前div是为了实现换行，就这换行研究了好久。。。
                  slot: 'content',
                },
                ['某个业务员的总下发金额（【每个任务的计划量 *单价】 之和；），或某个任务的费用金额（计划量 * 单价；'],
              ),
              h('span', {
                //问号模块
                class: {
                  'el-icon-question': true,
                },
              }),
            ],
          ),
        ];
      },
      renderHeaderIII: function (h, { column, $index }) {
        return [
          column.label,
          h(
            'el-tooltip',
            {
              props: {
                placement: 'top',
                effect: 'dark',
                //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
              },
            },
            [
              h(
                'div',
                {
                  //当前div是为了实现换行，就这换行研究了好久。。。
                  slot: 'content',
                },
                ['某个业务员某个任务的计划需要完成的任务量(注：不限量任务无法统计占比）；'],
              ),
              h('span', {
                //问号模块
                class: {
                  'el-icon-question': true,
                },
              }),
            ],
          ),
        ];
      },
      handleCounterChange(goodsIndex, detail) {
        var tableDataII = this.tableDataII;
        console.log();
        if (detail.goodsInfo && detail.goodsInfo.length != 0) {
          var list = detail.goodsInfo;
          list.forEach((item) => {
            item.goodsCount = Math.ceil(detail.taskTotal / list.length);
          });
          this.tableDataII[goodsIndex].goodsInfo = list;
        }
      },
      //点击填写数量
      addAmount(goodsIndex, list) {
        this.visible2 = true;
        this.goodsIndex = goodsIndex;
        this.tableData = list;
      },
      getDetail() {
        var self = this;
        if (!this.$route.query.guid) return;
        if (this.$route.query.is_edit) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }

        var req = {
          guid: this.$route.query.guid,
          approveGuid:this.$route.query.approveGuid,
        };
        this.fullscreenLoading = true;
        self.api.get(`/${serverConfig.msSalesPerformService}/task/data/get-detail`, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            var detail = res.data.data;
            this.taskTitle = detail.taskTitle;
            this.tenantName = detail.tenantName;
            this.timeType = detail.timeType;
            this.autoForecastJson = detail.autoForecastJson?JSON.parse(detail.autoForecastJson):{
                parmValue1:'',
                parmValue2:'',
                parmValue3:'',
                detailParam:[]
            }
            setTimeout(() => {
              this.startTime = moment(detail.startTime).format('YYYY-MM-DD');
              this.endTime = moment(detail.endTime).format('YYYY-MM-DD');
            }, 100);
            this.departmentData = [
              {
                organisationName: detail.senderStaffName,
                guid: detail.senderStaffGuid,
              },
            ];
            this.departmentList = [
              {
                organisationName: detail.senderStaffName,
                guid: detail.senderStaffGuid,
              },
            ];

            this.tableDataII = detail.taskDetailList;
            var tableDataII = this.tableDataII;
            tableDataII.forEach((item) => {
              if (item.goodsInfo) {
                item.goodsInfo = JSON.parse(item.goodsInfo);
              }
              if (item.taskPrice && item.taskTotal) {
                item.taskTarget = item.taskPrice * item.taskTotal;
                item.taskTarget = item.taskTarget.toFixed(2);
              } else {
                item.taskTarget = 0;
              }
            });
            this.tableDataII = tableDataII;

            this.detail = detail;
            this.isChangeService = detail.isChangeService || 'N'
            // this.changeServiceType = detail.changeServiceType||'2'


            this.multipleSelection = detail.taskDetailList;
            this.$forceUpdate();
          } else {
            self.$message.error(res.data.msg);
          }
          this.getApprovalList();
          this.sumPage.tenantGuid = this.detail.tenantGuid;
          this.getSumList();
        });
 
      },
      getSumList() {
        let req = JSON.parse(JSON.stringify(this.sumPage));
        this.fullscreenLoading = true;
        this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/staff/detail-history`, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.detailData = res.data.data&&res.data.data.records || [];
            this.detailData.forEach(item => {
              item.guid = this.generateUUID();
              item.detailList.forEach(el => {
                el.guid = this.generateUUID();
              })
            })
            this.sumPage.totalPage = res.data.data&&res.data.data.totalPages;
           this.sumPage.totalRows = res.data.data&&res.data.data.totalRows;
           this.getSum()
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      getSum() {
        this.sumAmount=null
        let req = JSON.parse(JSON.stringify(this.sumPage));
        this.fullscreenLoading = true;
        this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-total-money`, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.sumAmount = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      generateUUID() {
        var d = new Date().getTime();
        if (window.performance && typeof window.performance.now === "function") {
          d += performance.now(); //use high-precision timer if available
        }
        var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
      },
      search(){
        this.detailData = [];
        this.sumPage.pageIndex = 1;
        this.getSumList();
      },
      emptySearch(){
        this.sumPage.keyword = '';
        this.sumPage.pageIndex = 1;
        this.detailData = [];
        this.getSumList();

      },
      handleSizeChange(val) {
        let self = this;
        self.sumPage.pageSize = val;
        this.getSumList();
      },
      handleCurrentChange(val) {
        let self = this;
        self.sumPage.pageIndex = val;
        this.getSumList();
      },
      //去分解
      submitReq() {
        var self = this;
        var req = {
          guid: this.$route.query.guid,
          state: '待派发',
          currentTenantGuid:localStorage.guid
        };
        var taskDetailList = [];
        var tableDataII = this.tableDataII;
        var isReturn = '';
        if (this.isChangeService == 'Y') {
          if (!this.newServiceTenantName) {
            this.$message.error('请选择新执行方');
            return;
          }
          if (this.departmentListII.length == 0) {
            this.$message.error('请选择新执行部门');
            return;
          }
          req.newServiceTenantName = this.newServiceTenantName;
          req.newServiceTenantGuid = this.newServiceTenantGuid;
          var organisationInfo = [];
          this.departmentListII.forEach((item) => {
            organisationInfo.push({
              guid: item.guid,
              name: item.organisationName,
              objectType:item.nodeType=='2'?'人员':'组织'

            });
          });
          req.organisationInfo = JSON.stringify(organisationInfo);
          req.isChangeService = 'Y';
          req.oldOrganisationInfo = this.detail.organisationInfo
        } else {
          req.newServiceTenantName = null;
          req.newServiceTenantGuid = null;
          req.organisationInfo = null;
          req.isChangeService = 'N';
          req.oldOrganisationInfo = null;
        }
        tableDataII.forEach((item) => {
          if (item.goodsInfo) {
            var goodsCountSum = 0;
            item.goodsInfo.forEach((l) => {
              goodsCountSum += l.goodsCount;
            });
            if (goodsCountSum !== item.taskTotal) {
              isReturn = '品种任务量之和必须等于任务总量';
            }
          }
          taskDetailList.push({
            guid: item.guid,
            taskPrice: +item.taskPrice,
            taskTotal: +item.taskTotal,
            goodsInfo: item.goodsInfo ? JSON.stringify(item.goodsInfo) : null,
            taskTotalType: item.taskTotalType
          });
        });
        if (isReturn) {
          this.$message.error(isReturn);
          return;
        }

        req.taskDetailList = taskDetailList;

        self
          .$confirm('请确保任务量都已填写准确哦，以免影响任务分解，是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            this.fullscreenLoading = true;
            self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/edit`, req).then((res) => {
              this.fullscreenLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.disabled = true;
                self.$message.success('分解成功');
                self.getDetail();
              } else {
                self.$message.error(res.data.msg);
              }
            });
          });
      },
      //确认发布
      surePost() {
        // let self = this;
        let req = {
          guid: this.$route.query.guid,
          state: '已派发',
          currentTenantGuid:localStorage.guid
        };
       // var staffList = self.getDeliverStaff(this.detail);
        // self
        //   .$confirm(`即将给 ${staffList} 人派发任务，请谨慎操作，确定发布？`, '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        //   })
        //   .then(() => {
            this.fullscreenLoading = true;
            this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/edit`, req).then((res) => {
              this.fullscreenLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                this.$message.success('提审成功');
                this.$router.go(-1);
                //this.getDetail();
              } else {
                this.$message.error(res.data.msg);
              }
            });
          // });
      },
      submitForm() {
        var goodsIndex = this.goodsIndex;
        this.visible2 = false;
        var taskTotal = 0;
        this.tableData.forEach((item) => {
          taskTotal += item.goodsCount;
        });
        this.tableDataII[goodsIndex].goodsInfo = this.tableData;
        this.tableDataII[goodsIndex].taskTotal = taskTotal;
      },
      getDeliverName(res) {
        var list = JSON.parse(res);
        var strList = [];
        list.forEach((item) => {
          strList.push(item.name);
        });
        return strList.join('、');
      },
      getReqName(res) {
        return JSON.parse(res).join('、');
      },
      getDeliverOrg(detail) {
        var taskDetailList = detail.taskDetailList;
        var orgList = [];
        taskDetailList.forEach((item) => {
          item.taskDetailOrganisationList.forEach((el) => {
            orgList.push(el.organisationGuid);
          });
        });

        var filterOrgList = new Set(orgList);

        return [...filterOrgList].length;
      },
      getDeliverStaff(detail) {
        var taskDetailList = detail.taskDetailList;
        var staffList = [];
        taskDetailList.forEach((item) => {
          item.taskDetailStaffList.forEach((el) => {
            staffList.push(el.staffGuid);
          });
        });
        var filterStaffList = new Set(staffList);
        return [...filterStaffList].length;
      },

      handleSelectionChange(val) {
        let self = this;
        self.multipleSelection = val;
      },

      //部门弹框选择
      handleNodeClick1(data) {
        this.departmentList = this.$refs.treeDep.getCheckedNodes(true);
        console.log();
        this.$forceUpdate();
      },
      //确定选择部门
      departmentSure() {
        this.departmentData = this.departmentList;
        this.visible3 = false;
      },
      handleSelectionChange1(val) {
        let self = this;
        self.delList = val;
        console.log(val);
      },
      //删除部门
      delDepartment() {
        let self = this;
        if (self.delList == null || self.delList.length == 0) {
          self.$message.error('请勾选成员！');
          return;
        }
        self.delList.forEach(function (j) {
          self.departmentList.forEach(function (i, index) {
            if (i.guid == j.guid) {
              self.departmentList.splice(index, 1);
              this.$refs.treeDep.setCheckedKeys([]);
            }
          });
        });
        self.delList.forEach(function (m) {
          self.area.forEach(function (n, idn) {
            if (JSON.parse(n).guid == m.guid) {
              self.area.splice(idn, 1);
            }
          });
        });
      },
      //删除单个部门
      delDepartmentSingle(index) {
        if (this.disabled) return;
        this.departmentData.splice(index, 1);
        this.departmentList = this.departmentData;
        this.area.splice(index, 1);
        this.$refs.treeDep.setCheckedKeys([]);
        // this.departmentList.splice(index,1)
      },
      handleCheckChange(data, checked, node) {
        if (checked == true) {
          this.checkedId = data.guid;
          this.$refs.treeDep.setCheckedNodes([data]);
        }
      },
      nodeClick(data, checked, node) {
        this.checkedId = data.guid;
        this.$refs.treeDep.setCheckedNodes([data]);
      },
      filterNodeDep(value, data) {
        if (!value) return true;
        return data.menuName.indexOf(value) !== -1;
      },
      seeOrg(detail) {
        this.visible4 = true;
        this.serachOrgTxt = '';
        this.taskDetail = detail;
        this.tableOrg = detail.taskDetailOrganisationList;
        this.tableOrg.forEach((item) => {
          item.planCount = !item.planCount && detail.taskTotalType == '不限量' ? '不限量' : item.planCount
          item.taskDetailStaffList = [];
        });

        this.tableOrg.forEach((i, index) => {
          detail.taskDetailStaffList.forEach((j) => {
            if (i.organisationName == j.organisationName) {
              i.taskDetailStaffList.push(j);
            }
          });
        });

        var tabHead = [
          {
            property: 'organisationName',
            label: '组织',
          },
          {
            property: 'planCount',
            label: '任务总量',
          },
        ];

        this.tableOrg.forEach((item, index) => {
          if (item.goodsInfo) {
            item.goods = JSON.parse(item.goodsInfo);
          }
        });

        this.tableOrg.forEach((p) => {
          if (p.goods) {
            p.goods.forEach((q) => {
              q.name = q.name + `(${q.goodsSpec})`;
              // q.name = q.name;
              p[q.name] = q.goodsCount;
            });
          }
        });
        var re = /[^\u4e00-\u9fa5]/;
        for (const k in this.tableOrg[0]) {
          var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
          if (reg.test(k)) {
            tabHead.push({
              property: k,
              label: k,
            });
          }
        }

        this.tabHead = tabHead;
        this.tableOriginOrg = this.tableOrg;

      },
      seePeople(detail) {
        this.taskStaffDetail = detail;
        this.visible5 = true;
        this.serachPeopleTxt = '';
        var taskDetailNoStaffList = [];
        console.log(detail)
        detail.taskDetailStaffList.forEach(item=>{
          if(item.planCount||detail.planCount=='不限量'){ //隐藏计划为0的
            taskDetailNoStaffList.push(item)
          }
        })
        this.tableStaff = taskDetailNoStaffList;
        
        var tabHead = [
          {
            property: 'staffName',
            label: '人员名称',
          },
          {
            property: 'planCount',
            label: '任务总量',
          },
        ];
        console.log(this.tableStaff)
        this.tableStaff.forEach((item, index) => {
          
          if (item.goodsInfo) {
            item.goods = JSON.parse(item.goodsInfo);
          }
        });

        this.tableStaff.forEach((p) => {
          if (this.taskStaffDetail.planCount == '不限量' && p.planCount == 0) {
            p.planCount = '不限量'
          }
          if (p.goods) {
            p.goods.forEach((q) => {
              if(!(q.name.indexOf('(')>-1&&q.name.indexOf(')')>-1)){
                q.name = q.name + `(${q.goodsSpec})`;
              }else{
                q.name = q.name 
              }
          
              p[q.name] = q.goodsCount;
            });
          }
        });

        for (const k in this.tableStaff[0]) {
          var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
          if (reg.test(k)) {
            tabHead.push({
              property: k,
              label: k,
            });
          }
        }
        console.log(this.tabHeadII);
        this.tabHeadII = tabHead;
        this.tableOriginStaff = this.tableStaff;
      },
      modifyStaff() {
        var flag = false;
        var flag1 = false;
        var tableStaff = this.tableStaff;
        tableStaff.forEach((item) => {
          for (const k in item) {
            var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
            if (reg.test(k)) {
              //中文
              item.goods.forEach((j) => {
                if (j.name == k) {
                  j.goodsCount = +item[k];
                }
                if (j.goodsCount == 0) {
                  flag = true;
                }
              });
            }
          }
        });
        var newlist = [];
        tableStaff.forEach((item) => {
          // if (item.planCount == 0) {
          //   flag = true;
          // }
          if (item.goods) {
            item.goodsInfo = JSON.stringify(item.goods);
            var count = 0;
            item.goods.forEach((item) => {
              count += item.goodsCount;
            });
            // if (item.planCount != count) {
            //   flag1 = true;
            // }
            newlist.push({
              guid: item.guid,
              taskTotal: item.planCount,
              goodsInfo: item.goodsInfo,
            });
          } else {
            newlist.push({
              guid: item.guid,
              taskTotal: item.planCount,
            });
          }
        });
        // if (flag) {
        //   this.$message.error('任务总量和商品不能为0');
        //   return;
        // }
        if (flag1) {
          this.$message.error('品种量之和必须和任务总量相等');
          return;
        }
        let self = this;
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/change-goods-info`, newlist).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('修改成功');
            self.visible5 = false;
            self.visible4 = false;
            self.getDetail();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      //导入-上传文件
      uploadImage(file) {
        this.fileList = file;
      },
      // modifyUplad() {
      //   let formData = new FormData();
      //   let file = this.fileList;
      //   if (file.length == 0) {
      //     this.$message.error('请上传文件清单！');
      //     return;
      //   }
      //   formData.append('file', file.file, file.filename);
      //   this.fullscreenLoading = true;
      //   this.api.postFile(`/${serverConfig.msSalesPerformService}/task/data/import-detail`, formData).then((res) => {
      //     this.fullscreenLoading = false;
      //     this.visible6 = false;
      //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
      //       this.$message.success('调整成功！');
      //       this.getDetail();
      //     } else {
      //       this.$message.error(res.data.msg);
      //     }
      //   });
      // },
      //导入-上传前校验
      beforeAvatarUpload(file) {
        let testmsg = file.name ? file.name.split('.')[1] : '';
        const isJPG = testmsg === 'xls' || testmsg === 'xlsx'||testmsg === 'xlsm';
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isJPG) {
          this.$message.error('文件格式不正确!');
        }
        if (!isLt2M) {
          this.$message.error('文件大小不能超过10MB!');
        }
        return isJPG && isLt2M;
      },
      downloadTemplate() {
        let self = this;
        self.fullscreenLoading = true;
        self.api
          .postJson(`/${serverConfig.msSalesPerformService}/task/data/export-detail?guid=${this.$route.query.guid}`)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      reportJx(colNames, datas, sheetName, fileNam) {
        let self = this;
        self.api
          .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
            colNames: colNames,
            datas: datas,
            sheetName: sheetName,
            fileNam: fileNam,
          })
          .then((res) => {
            let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            let fileName = fileNam;
            let objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = fileName;
            link.href = objectUrl;
            link.click();
            self.fullscreenLoading = false;
          });
      },
      chooseDepartmentPerson() {
        let departmentListII = this.departmentListII;
        let personList = [];
        departmentListII.forEach(i => {
          personList.push(i.guid);
        });
        this.$refs.chooseDepartment.open(personList);
      },
      //获取人员部门名称
      getDepartmentName(list) {
        if (typeof list == 'string') {
          list = JSON.parse(list);
        }
        let personArr = [];
        let personTip = '';
        let departmentArr = [];
        let departmentTip = '';
        let personNum = 0;
        let departmentNum = 0;
        if (list && list.length > 0) {
          list.forEach(i => {
            if (i.objectType == '人员') {
              personArr.push(i.organisationName || i.name);
              personNum = personNum + 1;
            } else {
              departmentNum = departmentNum + 1;
              departmentArr.push(i.organisationName || i.name);
            }
          });
        }
        personTip =
          personArr.length > 2
            ? personArr.splice(0, 2).join('、') + `等${personNum}个人`
            : personArr.splice(0, 2).join('、');
        console.log(personArr);
        departmentTip =
          departmentArr.length > 2
            ? departmentArr.splice(0, 2).join('、') + `等${departmentNum}个部门`
            : departmentArr.splice(0, 2).join('、');
        return departmentTip + (departmentTip && personTip ? '，' : '') + personTip;
      },
      //获取完整的部门和人员
      getDepartmentNameAll(list,flg) {
        if (typeof list == 'string') {
          list = JSON.parse(list);
        }
        let personArr = [];
        let personTip = '';
        let departmentArr = [];
        let departmentTip = '';
        let personNum = 0;
        let departmentNum = 0;
        if (list && list.length > 0) {
          list.forEach(i => {
            if (i.nodeType == 2) {
              personArr.push(i.organisationName || i.name);
              personNum = personNum + 1;
            } else {
              departmentNum = departmentNum + 1;
              departmentArr.push(i.organisationName || i.name);
            }
          });
        }
        personTip = personArr.join('、');
        console.log(111,personArr);
        departmentTip =departmentArr.join('、')
        let str=departmentTip + (departmentTip && personTip ? '，' : '') + personTip
        if(flg==1){
          return departmentTip
        }else{
          return personTip
        }
      },
        //提交所选部门
      onDepartmentSelect([personGuidList, departmentData]) {
        let departmentListII = [];
        departmentData.forEach(item => {
          departmentListII.push({
            organisationName: item.name,
            guid: item.guid,
            nodeType: item.nodeType
          })
        })
        this.departmentListII = departmentListII;
      },
      handleSelectFactory(val) {
        var tenantList = this.tenantList;
        this.newServiceTenantName = val;
        tenantList.forEach((item) => {
          if (item.tenantName == this.newServiceTenantName) {
            this.newServiceTenantGuid = item.guid;
          }
        });
      },
      modifyPerson() {
        this.taskDetailGuid = '';
        this.staffList = [];
        this.detailGuid = '';
        this.taskCount = '';
        this.staffGuid = '';
        this.organisationNames = ''
        this.visible8 = true;
        if (this.tableDataII.length == 1) {
          this.taskChange(this.tableDataII[0].guid);
        }
      },
      sureTaskModify() {
        if (!this.taskDetailGuid) {
          this.$message.error('请选择任务');
          retuen;
        }
        if (!this.staffGuid) {
          this.$message.error('请选择人员');
          retuen;
        }
        let req = {
          taskDetailGuid: this.taskDetailGuid,
          guid: this.detailGuid || null,
          taskCount: this.taskCount,
          staffGuid: this.staffGuid
        }
        this.fullscreenLoading = true;
        this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/edit-staff-task-count`, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('提交成功');
            // this.visible8 = false;

            this.getDetail();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      taskChange(val) {
        let self = this;
        let query = {
          taskDetailGuid: val
        };
        this.staffList = [];
        this.detailGuid = '';
        // this.taskCount = '';
        // this.staffGuid = '';
        this.organisationNames = ''

        this.taskDetailGuid = val;
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-staff-task-info`, query).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.staffList = res.data.data;
            if(this.staffGuid){
              this.staffList.forEach(item=>{
                if(item.staffGuid ==this.staffGuid){
                  this.taskCount = item.taskCount;
                  this.organisationNames = item.organisationNames.join('、');
                  this.detailGuid = item.guid;
                }
              })
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });

      },
      staffChange(val) {
        this.staffList.forEach(item => {
          if (item.staffGuid == val) {
            this.checkStaff(item);
            this.detailGuid = item.guid;
            this.taskCount = item.taskCount || 0;
            this.organisationNames = item.organisationNames.join('、');
          }
        })
     
      },

      checkStaff(item) {
        let req = {
          tenantGuid: this.detail.tenantGuid,
          objectList: [{
            objectName: item.staffName,
            objectGuid: item.staffGuid,
            objectType: '人员',
          }]
        }
        this.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-task/data/check-task-object`, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if(res.data.data){
              this.staffGuid = '';
              this.taskCount = '';
              this.organisationNames = '';
              this.$message.error(res.data.data);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });

      },
      getApprovalList() {
        let userinfo = JSON.parse(localStorage.userInfo);
        let token = localStorage.token;
        console.log('-------------')
        console.log(this.detail)
        if (this.detail.bizApproveVO && this.$route.query.guid && this.detail.bizApproveVO.camundaInstanceId && this.detail.bizApproveVO.camundaDeploymentId) {
          this.iframeSh = true;
          this.iframeSrc = bpmnroute + '/iframeBpmn?processInstanceId=' + this.detail.bizApproveVO.camundaInstanceId + '&camundaDeploymentId=' + this.detail.bizApproveVO.camundaDeploymentId + '&token=' + token;
          return;
        }
        let req = {
          tenantGuid: localStorage.guid,
          flowType: '00015',
          staffGuid: userinfo.staffGuid
        }
        this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (!res.data.data) {
              this.$message.error('没有找到规则,请先联系运营人员设置当前部门的流程规则');
              this.iframeSh = false;
            } else {
              this.iframeSh = true;
              this.iframeSrc = bpmnroute + '/iframeBpmnE?deploymentId=' + res.data.data + '&token=' + token;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      //驳回提交
      toRejectSubmit() {
        if (this.approveSuggest == '') {
          this.$message.error('请填写驳回理由！');
          return;
        }
        let query = {
          guid: this.detail.bizApproveVO.approveGuid,
          flowType: '00015',
          approveSuggest: this.approveSuggest,
          approveStaffGuid: this.currentStaffGuid
        };
        this.fullscreenLoading = true;

        this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.rejectDialogVisible = false;
            this.$message.success('驳回成功！');
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      //通过
      toPassSubmit() {
        let query = {
          guid: this.detail.bizApproveVO.approveGuid,
          flowType: '00015',
          approveSuggest: this.approveSuggest,
          approveStaffGuid: this.currentStaffGuid
        };
        this.fullscreenLoading = true;
        this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.passDialogVisible = false;
            this.$message.success('审批通过！');
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        });

      },
      //撤回
      toRevoke() {
        let self = this;
        this.$confirm('撤销后，该流程将不再进行审核，确定这样操作吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          let query = {
            guid: this.detail.bizApproveVO.approveGuid,
            flowType: '00015',
            approveStaffGuid: this.currentStaffGuid
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
          .catch(() => {
            self.$message({
              type: 'info',
              message: '已取消操作！',
            });
          });
      }

    },
  };
</script> 
<style scoped>
.title-search{
  display:flex;
  justify-content:space-between;
  margin-bottom: 20px;
  align-items: center;

}
.search-box{
  width:260px
}

.total-tip{
  margin-left: 420px;
}
.total-tip span {
  color: #ff5f1f;

}
.content {
  background: #fff;
  font-size: 18px;
}
/deep/.el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
}

/deep/.el-form-item__content {
  margin-left: 0px !important;
}

.base-info {
  display: flex;
  align-items: center;
  margin-left: 23px;
  margin-bottom: 10px;
}
.base-info .base-title {
  word-break: keep-all;
  font-size: 14px;
  display: flex;
}
.depart-choose {
  width: 300px;
  height: 34px;
  border: 1px solid #dcdfe6;
  box-sizing: content-box;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-left: 6px;
}
.depart-choose span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
.place-choose {
  padding-left: 10px;
  color: rgb(185, 185, 185);
}
.place-show {
  padding-left: 20px;
}
.p16 {
  padding-top: 0;
  padding-left: 30px;
  padding-right: 30px;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.management-list {
  display: flex;
  align-items: center;
  margin-left: 64px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #606266;
}
.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}
.management-name {
  flex-shrink: 0;
}
.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  /* border: 1px solid grey; */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
  border-radius: 20px;
  background: #DEEFEF;
  border: 0 none;
}
.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}
.input-item .input-title {
  margin-right: 14px;
}
input:disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}
.date {
  font-size: 14px;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  padding-left: 30px;
  background: #fff;
}
.date.first{
  padding-top: 10px;
}
.title {
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  background: #fff;
  color: #323233;
  padding:16px 0 10px 20px;
  margin-bottom: 0;
}
.title span {
  width: 6px;
  height: 14px;
  background: #4fa1a4;
  display: inline-block;
  margin-right: 10px;
}
.row-import {
  display: flex;
  margin-bottom: 20px;
  margin-left: 18px;
}
.row-import .left {
  font-size: 14px;
  font-weight: bold;
  margin-right: 20px;
  padding-top: 4px;
}
.row-import .right {
  font-size: 14px;
}
.tipInfo {
  margin-top: 10px;
  color: #646464;
  line-height: 30px;
}
.task-tips{
  font-size:14px;
  font-style:normal;
  font-weight:normal;color:red;
}
.ai-tips{
  height: 26px;
  background: #FFEEE3;
  color:#FF741E;
  line-height: 26px;
  font-size:13px;
  padding-left:10px;
}
.download-btns{
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  align-items: center;
}
.ai-item .lable{
  font-size:14px;
  color:#232323;
}
.ai-item{
  margin-top:20px;
}
.ai-item .value{
  color:#333;
  font-weight:600;
   margin-left:5px;
}
.ai-item .other1{
  color:#333;
  font-weight:600;
  margin-left:5px;
}
.ai-item .other2{
  color:#4fa1a4;
  text-decoration: underline;
  cursor:pointer;
}
.ai-item .ai-color{
  color: #4fa1a4;
  margin-left:8px;
}
.download-btns .lable{
  font-size:14px;
  color:#232323;
  flex:1;
}

.download-btns .btns{
  flex:1;
  display:flex;
  color:#323233;
  justify-content: flex-end;

}
.download-btns .btn1{
  margin-right:20px;
}
.download-btns .btn1,.download-btns .btn2{
  border:1px solid #D9D9D9;
  padding:6px;
  border-radius:4px;
}

/deep/.ai-class .el-dialog--center .el-dialog__body{
  padding:0 25px;
}
.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;

}

.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
}
.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;

}

.header .back {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}
.header .task-title{
    flex:1;
    font-weight:500px;
}
.basic-conetent{
  background: #fff;
  margin-bottom:4px;
}
.basic-conetent .content-name {
  width: 380px;
  text-align: left;
  white-space: nowrap;  
  overflow: hidden;  
  text-overflow: ellipsis;  
}
.btn-groups{
  background: #fff;
}
.btn-groups .btn-common{
  width: 120px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn-border-green{
  background: #fff;
  color: #4fa1a4;
  border: 1px solid #4fa1a4;
}
.btn-border-gray{
  background: #f0f0f0;
  color: #323233;
  border: 1px solid #dcdee0; 
}
.btn-operate{
  text-align: right;
}
.btn-operate .btn-common:last-child{
  margin-right: 30px;
}
.approve-item-list{
  display: flex;
  background: #fff;
  margin-bottom: 4px;
  align-items: center;
  padding-bottom: 16px;
  position:relative;
}
.approve-item-list .item{
  margin-left:40px;
  display: flex;
}
.approve-item-list .label{
  color: #606266;
  margin-right: 15px;
}
.approve-item-list .item.first{
  margin-left:50px;
}
.approve-item-list  img {
  position: absolute;
  right: 40px;
  width: 70px;
  bottom: 8px;
}
/deep/ .table_header {
  background-color: #F2F2F2 !important;
  padding: 5px 0;
  color: #323233;
  width:100%;
}

/deep/ .el-table td {
  padding: 5px 0px;
}
.detail-table{
  background: #fff;
  margin:0 auto;
  padding:0 20px 20px 20px;
}
.detail-table .search{
  display:flex;
  align-items:center;
  padding-left:20px;

}
.detail-table .search .input{
  background:none;
  outline:none;
  border:none;
  width:200px;
  height:32px;
  margin:10px;
  border: 1px solid rgba(217,217,217,1);
  border-radius: 2px;
  padding-left: 10px;
}
.detail-table .search .btn{
  background: #4FA1A4;
  border-radius: 2px;
  color:#fff;
  width:60px;
  height:28px;
  line-height:28px;
  text-align: center;
  margin-left:10px;
  border:1px solid transparent;
  cursor: pointer;
}
.detail-table .search .btn.gray{
  border:1px solid #D9D9D9 ;
  color:#212121;
  background: #fff;
}


/deep/ .el-table__row--level-1 .el-table__expand-icon{
 color:transparent;
}
/* /deep/ .el-table__body{
  width:100% !important;
}
/deep/ .el-table__header{
  width:100% !important;
} */

</style>
